const getBaseUrl = () => {
  if (window.HYBRID) {
    // if (window.location.host.includes("localhost")) {
    //   return `${window.location.protocol}//${window.location.hostname}:8000/`;
    // }
    return `${window.location.protocol}//back.educandus.com.br/`;
  }

  if (window.BACKEND) {
    return window.BACKEND;
  }

  const suffix = window.location.host.includes(".com.br") ? ".com.br" : ".net";

  if (window.location.host.includes("localhost")) {
    if (window.location.port === "3000") {
      return "http://backhomologa.educandus.com.br/";
    }
    return "http://localhost:8000/";
  }
  if (window.location.host.includes("homologa")) {
    return `${window.location.protocol}//backhomologa.educandus${suffix}/`;
  }
  if (window.location.host.includes("alfa")) {
    return `${window.location.protocol}//alfaback.educandus${suffix}/`;
  }
  if (window.location.host.includes("beta")) {
    return `${window.location.protocol}//betaback.educandus${suffix}/`;
  }

  return `${window.location.protocol}//back.educandus${suffix}/`;
};

const getExamMigrationUrl = () => {
  if (window.location.host.includes("localhost")) {
    return "https://homologa.adrbackend.educandus.com.br/ava/exam-migration-ava-adr";
  }

  if (window.location.host.includes("avahomologa.educandus.com.br")) {
    return "https://homologa.adrbackend.educandus.com.br/ava/exam-migration-ava-adr";
  }

  if (window.location.host.includes("ava.educandus.com.br")) {
    return "https://adrbackend.educandus.com.br/ava/exam-migration-ava-adr";
  }

  return "https://adrbackend.educandus.com.br/ava/exam-migration-ava-adr";
};

const baseUrl = getBaseUrl();

export default {
  /*
  // PRODUÇÃO
  interface : 'http://back.educandus.net/interface/interface.html',
  api : 'http://back.educandus.net/api/',
  img : 'http://back.educandus.net/',
  node: 'https://educandus-node.herokuapp.com/',
  public : 'http://back.educandus.net/',

  // HOMOLOGAÇÃO
  interface: "http://back.homologa.educandus.com.br/interface/interface.html",
  api: "http://back.homologa.educandus.com.br/api/",
  img: "http://back.homologa.educandus.com.br/",
  node: "https://educandus-node.herokuapp.com/",
  public: "http://back.homologa.educandus.com.br/",

  
  // LOCAL
  interface : 'http://127.0.0.1:8000/interface/interface.html',
  api : 'http://127.0.0.1:8000/api/',
  img : 'http://127.0.0.1:8000/',
  node: 'http://127.0.0.1:8000',
  node: 'https://educandus-node.herokuapp.com/',
  public: 'http://127.0.0.1:8000/',
  */

  interface: `${baseUrl}interface/interface.html`,
  api: `${baseUrl}api/`,
  img: baseUrl,
  node: window.BACKEND_NODE
    ? window.BACKEND_NODE
    : "https://educandus-node.herokuapp.com/",
  public: baseUrl,
  examMigrationAvaAdr: getExamMigrationUrl()
};
